export const INITIALS = {
  en: { name: 'AMANBEK', surname: 'BAKTYBAEV', patronymic: 'ASKAROVICH' },
  ru: { name: 'АМАНБЕК', surname: 'БАКТЫБАЕВ', patronymic: 'АСКАРОВИЧ' },
};
